import script from "./FacilityManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./FacilityManagement.vue?vue&type=script&setup=true&lang=js"

import "./FacilityManagement.vue?vue&type=style&index=0&id=f5e75920&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f5e75920"]])

export default __exports__